import { join } from "@p0security/frontend-core/react";
import { Permission } from "@p0security/shared/types/permission";
import { Button, Flex, Typography } from "@p0security/ui";
import { useNavigateWithEnv } from "components/Assessment/hooks/useNavigateWithEnv";
import { Identity } from "components/common/Identity";
import { formatDistance } from "date-fns";
import React, { useCallback } from "react";

import { requestDescription } from "../requestUtils";
import { RequestAttribution } from "../types.ts";
import { PermissionLocation } from "./PermissionLocation";

const DetailsLink: React.FC<{ requestId: string }> = ({ requestId }) => {
  const navigate = useNavigateWithEnv();

  const showRequestInfo = useCallback(() => {
    navigate(requestId);
  }, [navigate, requestId]);
  return (
    <Button type="link" onClick={showRequestInfo}>
      <Typography.Text className="underline">Details</Typography.Text>
    </Button>
  );
};

export const PermissionPreview: React.FC<{
  requestor: RequestAttribution[];
  verb: string;
  reason?: string;
  permission: Permission;
  createdAt?: number;
  approverType?: string;
  approverDetail?: string;
  requestId?: string;
}> = ({
  requestor,
  verb,
  reason,
  permission,
  createdAt: approvedAt,
  approverType,
  approverDetail,
  requestId,
}) => (
  <Flex gap={8} vertical>
    <div>
      <Identity value={requestor[0]} className="font-bold" />
      {requestor.length > 1 ? (
        <>
          {" "}
          (
          {join(
            requestor
              .slice(1)
              .map((step, ix) => (
                <Identity value={step} key={ix} className="font-bold" />
              )),
            ", "
          )}
          )
        </>
      ) : (
        ""
      )}{" "}
      {verb}{" "}
      <Typography.Text strong>{requestDescription(permission)}</Typography.Text>{" "}
      in <PermissionLocation permission={permission} />.
      {approvedAt ? (
        <Typography.Text>
          {" "}
          Approved {formatDistance(approvedAt, Date.now())} ago by{" "}
          <Typography.Text strong={approverType !== "evidence"}>
            {approverDetail}
          </Typography.Text>
          . {!reason && requestId && <DetailsLink requestId={requestId} />}
        </Typography.Text>
      ) : (
        !reason && requestId && <DetailsLink requestId={requestId} />
      )}
    </div>
    {reason && (
      <div>
        <Typography.Text type="secondary">Reason: {reason}</Typography.Text>.{" "}
        {requestId && <DetailsLink requestId={requestId} />}
      </div>
    )}
  </Flex>
);
